import { SubAPI } from "./SubAPI";
export class QuoteHardware extends SubAPI {
    bulkUpdateOpenings(input) { return this.fetcher.post("/api/quote-hardware/bulk-update-openings", input); }
    reSequence(input) { return this.fetcher.post("/api/quote-hardware/re-sequence", input); }
    forceRecalculate(input) { return this.fetcher.post("/api/quote-hardware/force-recalculate", input); }
    bulkEditProduct(input) { return this.fetcher.post("/api/quote-hardware/bulk-edit-product", input); }
    updateHardwareGroupLink(input) { return this.fetcher.post("/api/quote-hardware/edit-opening-link", input); }
    upsertItemSecondary(input) { return this.fetcher.post("/api/quote-hardware/item-secondary", input); }
    listWithContents(input) { return this.fetcher.get("/api/quote-hardware/with-content", input); }
    list(input) { return this.fetcher.get("/api/quote-hardware", input); }
    upsert(input) { return this.fetcher.post("/api/quote-hardware", input); }
    upsertTask(input) { return this.fetcher.post("/api/quote-hardware/task", input); }
    mergeCandidates(input) { return this.fetcher.get("/api/quote-hardware/merge-candidates", input); }
    merge(input) { return this.fetcher.post("/api/quote-hardware/merge", input); }
}
